import React from 'react';
import { HTML, Image } from '../../components/';
import CardBase from '../../components/CardBase/CardBase';
import { getMediaImage } from '../../components/Media/Image/utils';
import { block } from '../../utils';
import './TutorialCard.css';
const b = block('tutorial-card');
function iconElement(icon, title) {
    const image = getMediaImage(icon !== null && icon !== void 0 ? icon : {});
    return React.createElement(Image, Object.assign({}, image, { alt: image.alt || title, className: b('icon') }));
}
const TutorialCard = (props) => {
    const { url, title, text, border, icon } = props;
    return (React.createElement(CardBase, { className: b(), url: url, border: border },
        React.createElement(CardBase.Content, null,
            icon && iconElement(icon, title),
            React.createElement("h6", { className: b('title') },
                React.createElement(HTML, null, title)),
            React.createElement(HTML, null, text))));
};
export default TutorialCard;
